// Single JS palette for components that use inline styles.
// Values mirror the CSS custom properties in App.css :root.
const theme = {
  purpleDark: '#1a1535',
  purpleBase: '#2d1b69',
  purpleLight: '#37003c',
  accentCyan: '#00f5ff',
  accentPink: '#ff00ff',
  accentPurple: '#a855f7',
  successGreen: '#00ff87',
  dangerRed: '#ff1744',
  warningOrange: '#ff9800',
  goldWinner: '#FFD700',
};

export default theme;
